import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PageUnderConstruction from '../../../../../../PageUnderConstruction';
import OrgRequestTable from "../../components/OrgRequestTable";
import useRequests from "./useRequests";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Организации",
    link: "/work/app/manage/resources/org"
  },
  {
    label: "Заявки организаций",
    link: "#"
  },
];

const OrgRequestList = () => {
  const { requestsData, getRequests } = useRequests();

  useEffect(() => {
    getRequests();
  }, []);

  return (
    <div>
      <Breadcrumbs items={items} />
      <OrgRequestTable requestsData={requestsData}
                    getRequests={getRequests}/>
    </div>
  );
};

export default OrgRequestList;
